// Platform → Modules page. Shared table methods are in tableMixin.js.

// Built in: the menu depends on them, so they can't be deleted, switched off or change type
// (same list as protectedModuleKeys() in api_platform_modules_helpers.php)
const PROTECTED_MODULE_KEYS = ["administration", "platform"];

// Ideas for the "Sample" button
const SAMPLE_MODULES = [
    { key: "pos", name: "Point of Sale", icon: "fa fa-shopping-cart", prefix: "pos_", description: "Sell at the counter, print receipts and close the till." },
    { key: "inventory", name: "Inventory", icon: "fa fa-cubes", prefix: "inventory_", description: "Items, stock levels, transfers and stock counts." },
    { key: "purchases", name: "Purchases", icon: "fa fa-truck", prefix: "purchases_", description: "Suppliers, purchase orders, bills and payments made." },
    { key: "accounting", name: "Accounting", icon: "fa fa-book", prefix: "accounting_", description: "Chart of accounts, journals, bank and reports." },
    { key: "hr_payroll", name: "HR & Payroll", icon: "fa fa-id-card-o", prefix: "hr_", description: "Employees, leave, payroll and payslips." },
    { key: "crm", name: "CRM", icon: "fa fa-handshake-o", prefix: "crm_", description: "Leads, follow-ups and the sales pipeline." },
    { key: "projects", name: "Projects", icon: "fa fa-tasks", prefix: "projects_", description: "Projects, tasks, time and billing." },
];

export default {
    name: "PlatformModules",
    methods: {
        // Administration and Platform are built in
        isProtectedModule(record) {
            return PROTECTED_MODULE_KEYS.includes(record?.module_key);
        },

        // Next free Order number (last one on screen + 1)
        nextSortOrder() {
            const orders = (this.tableData?.records || []).map((r) => Number(r.sort_order) || 0);
            return orders.length ? Math.max(...orders) + 1 : 1;
        },

        /* ---------------- Sample button ---------------- */
        addSampleData() {
            // Clear old messages from a previous save
            this.defaultAlert = this.getDefaultAlert();

            // Prefer a module that is not in the table yet
            const usedKeys = (this.tableData?.records || []).map((r) => r.module_key);
            const unused = SAMPLE_MODULES.filter((m) => !usedKeys.includes(m.key));
            const list = unused.length ? unused : SAMPLE_MODULES;
            const sample = list[Math.floor(Math.random() * list.length)];

            this.formInputs = {
                ...this.getDefaultFormInputs(),
                id: this.formInputs.id,                 // keep the id when editing
                module_key: this.isEditing ? this.formInputs.module_key : sample.key,
                module_name: sample.name,
                module_type: "selectable",
                sort_order: this.isEditing ? this.formInputs.sort_order : this.nextSortOrder(),
                icon: sample.icon,
                permission_prefixes: sample.prefix,
                description: sample.description,
                is_default: false,
                is_active: true,
            };

            this.submitted = false;
            this.$clearValidationStates("#recordForm");
            this.$scrollToTopModal("recordFormModal");
        },
    },
};